import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GeneralAction, selectAccessibilityMode } from 'reducers/misc';
import { PUBLIC_SITE_URL } from 'appConstants';
import { endpoints } from 'endpoints.config';
import { useFetchContentAndCache } from 'hooks/useFetchContentAndCache';
import FacebookIcon from 'images/Icon_Social_01.png';
import TwitterIcon from 'images/Icon_Social_02.png';
import { getYear } from 'date-fns';
import Cookies from 'universal-cookie';

interface FooterItem {
  id: number;
  name: string;
  url: string;
}

interface FooterItemsResponse {
  navigationLinks: FooterItem[];
}

const GENERIC_PAGE_PATH = '/info';

const Footer: React.FC = () => {
  const dispatch = useDispatch();
  const accessibilityMode = useSelector(selectAccessibilityMode);

  const footerItems = useFetchContentAndCache<FooterItemsResponse>(
    endpoints.public.navigation.footerLinks,
    'footerLinks'
  );

  const cookies = new Cookies();
  const cookieBannerSetting = cookies.get('cookie_settings');

  const toggleAccessibilityMode = () =>
    dispatch({ type: GeneralAction.TOGGLE_ACCESSIBILITY_MODE });

  return (
    <footer className="Footer">
      <div className="FooterContent WidthContent">
        <div className="LeftSection">
          <div className="SocialMediaLinks">
            <a
              href="https://en-gb.facebook.com/getset4education"
              className="Btn BtnGrey"
              target="_blank"
              rel="noreferrer"
              aria-label="Go to Get Set 4 Education facebook page"
            >
              <img src={FacebookIcon} alt="Facebook" />
            </a>
            <a
              href="https://twitter.com/getset4ed"
              className="Btn BtnGrey"
              target="_blank"
              rel="noreferrer"
              aria-label="Go to Get Set 4 Education twitter page"
            >
              <img src={TwitterIcon} alt="Twitter" />
            </a>
          </div>
          <div className="FooterLinks">
            {footerItems &&
              footerItems.navigationLinks.map((item, index) => (
                <div key={'FooterLink' + index} className="FooterLink">
                  <a
                    href={`${PUBLIC_SITE_URL}${GENERIC_PAGE_PATH}${item.url}`}
                    aria-label="Go to Terms and conditions page"
                  >
                    {item.name}
                  </a>
                </div>
              ))}
            {cookieBannerSetting && cookieBannerSetting !== "functional" && cookieBannerSetting !== "functional_and_marketing" && 
              <div className="FooterLink" onClick={toggleAccessibilityMode}>
                <span>
                  {accessibilityMode
                    ? 'Turn off accessibility mode'
                    : 'Turn on accessibility mode'}
                </span>
              </div>
            }
          </div>
        </div>
        <div className="RightSection">
          <div className="Copyright">
            <span>
              Copyright &#169;{getYear(new Date())} Get Set 4 Education. All rights
              reserved.{' '}
            </span>
            <span> | </span>
            <span>
              {' '}
              Website development by{' '}
              <a
                href="https://www.avamae.co.uk/"
                target="_blank"
                rel="noreferrer"
                aria-label="Go to AVAMAE website"
              >
                AVAMAE
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
